const colorSelect = {
  name: 'color',
  type: 'select',
  size: 'full',
  label: 'Цвет',
  options: [
    {
      value: '#5f8eff',
      style: { background: '#5f8eff', color: '#FFF' },
      label: 'Оттеннок синего #D04A02',
    },
    {
      value: '#0048f4',
      style: { background: '#0048f4', color: '#FFF' },
      label: 'Второстепенный (акцентный) #0048f4',
    },
    {
      value: '#030d9c',
      style: { background: '#030d9c', color: '#FFF' },
      label: 'Основной синий #030d9c',
    },
    {
      value: '#141414',
      style: { background: '#141414', color: '#FFF' },
      label: 'Черный #141414',
    },
    {
      value: '#2D2D2D',
      style: { background: '#2D2D2D', color: '#FFF' },
      label: 'Серый 1 #2D2D2D',
    },
    {
      value: '#464646',
      style: { background: '#464646', color: '#FFF' },
      label: 'Серый 2 #464646',
    },
    {
      value: '#7D7D7D',
      style: { background: '#7D7D7D', color: '#FFF' },
      label: 'Серый 3 #7D7D7D',
    },
    {
      value: '#C5C5C5',
      style: { background: '#C5C5C5' },
      label: 'Серый 4 #C5C5C5',
    },
  ],
};

const colorSelectLine2 = JSON.parse(JSON.stringify(colorSelect));
colorSelectLine2.options.unshift({
  value: '#FFF',
  style: { background: '#FFF' },
  label: 'Белый #FFF',
});

// eslint-disable-next-line no-sparse-arrays
export default [
  //  _  _   __   __  __ _    ____  __     __    ___  __ _  ____
  // ( \/ ) / _\ (  )(  ( \  (  _ \(  )   /  \  / __)(  / )/ ___)
  // / \/ \/    \ )( /    /   ) _ (/ (_/\(  O )( (__  )  ( \___ \
  // \_)(_/\_/\_/(__)\_)__)  (____/\____/ \__/  \___)(__\_)(____/
  //

  // Заголовок уровень 1
  {
    sort: 10,
    type: 'heading_level_1',
    blockType: 'heading',
    label: 'Заголовок H1',
    canBeChild: true,
    forms: [
      {
        name: 'group_heading',
        label: 'Заголовок H1',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
        ],
      },
    ],
    content: {
      group_heading: [
        {
          title: 'Заголовок первого уровня',
        },
      ],
    },
  },
  // Заголовок уровень 2
  {
    sort: 12,
    type: 'heading_level_2',
    blockType: 'heading',
    label: 'Заголовок H2',
    canBeChild: true,
    forms: [
      {
        name: 'group_heading',
        label: 'Заголовок H2',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
        ],
      },
    ],
    content: {
      group_heading: [
        {
          title: 'Заголовок второго уровня',
        },
      ],
    },
  },
  // Заголовок уровень3
  {
    sort: 13,
    type: 'heading_level_3',
    blockType: 'heading',
    label: 'Заголовок H3',
    canBeChild: true,
    forms: [
      {
        name: 'group_heading',
        label: 'Заголовок H3',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
        ],
      },
    ],
    content: {
      group_heading: [
        {
          title: 'Заголовок третьего уровня',
        },
      ],
    },
  },
  // изображение
  {
    sort: 40,
    type: 'image',
    blockType: 'gallery',
    label: 'Изображение',
    canBeChild: true,
    forms: [
      {
        name: 'group_image',
        label: 'Изображение',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: 'Изображение',
          },
        ],
      },
    ],
    content: {
      group_image: [
        {
          image: '/static/img/work/collage-img.png',
        },
      ],
    },
  },
  // изображение ссылка
  {
    sort: 40,
    type: 'image-link',
    blockType: 'gallery',
    label: 'Изображение-ссылка',
    canBeChild: true,
    forms: [
      {
        name: 'group_image',
        label: 'Изображение',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: 'Изображение',
          },
          {
            name: 'link_url',
            type: 'text',
            size: 'full',
            label: 'Адрес ссылки',
          },
        ],
      },
    ],
    content: {
      group_image: [
        {
          image: '/static/img/work/collage-img.png',
          link_url: '/',
        },
      ],
    },
  },
  // html text
  {
    sort: 30,
    type: 'html_editor',
    blockType: 'html',
    label: 'Текст',
    canBeChild: true,
    forms: [
      {
        name: 'group_html',
        label: 'Текст',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Содержимое блока',
          },
        ],
      },
    ],
    content: {
      group_html: [
        {
          text:
            '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ea repellat minima eum amet ipsa aut nesciunt vitae deserunt tempore, optio illum iste vero laborum suscipit cum saepe explicabo illo. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum reiciendis ex enim officia provident nobis, et consectetur rerum quo excepturi omnis dolorem aut quisquam quos iste quaerat porro. Minima, fugiat? Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corrupti amet praesentium tenetur quibusdam, rerum veritatis modi perspiciatis iusto, nam quae odit iure, eum mollitia autem veniam quasi magnam voluptatum beatae!</p>',
        },
      ],
    },
  },
  // html в две колонки
  {
    sort: 30,
    type: 'html_editor_columns',
    blockType: 'html',
    label: 'Текст в 2 колонки',
    canBeChild: true,
    forms: [
      {
        name: 'group_html',
        label: 'Текст',
        multiple: {
          min: 2,
          max: 2,
        },
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Содержимое блока',
          },
        ],
      },
    ],
    content: {
      group_html: [
        {
          text:
            '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ea repellat minima eum amet ipsa aut nesciunt vitae deserunt tempore, optio illum iste vero laborum suscipit cum saepe explicabo illo. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum reiciendis ex enim officia provident nobis, et consectetur rerum quo excepturi omnis dolorem aut quisquam quos iste quaerat porro. Minima, fugiat? Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corrupti amet praesentium tenetur quibusdam, rerum veritatis modi perspiciatis iusto, nam quae odit iure, eum mollitia autem veniam quasi magnam voluptatum beatae!</p>',
        },
        {
          text:
            '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ea repellat minima eum amet ipsa aut nesciunt vitae deserunt tempore, optio illum iste vero laborum suscipit cum saepe explicabo illo. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum reiciendis ex enim officia provident nobis, et consectetur rerum quo excepturi omnis dolorem aut quisquam quos iste quaerat porro. Minima, fugiat? Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corrupti amet praesentium tenetur quibusdam, rerum veritatis modi perspiciatis iusto, nam quae odit iure, eum mollitia autem veniam quasi magnam voluptatum beatae!</p>',
        },
      ],
    },
  },
  // большой текст
  {
    sort: 30,
    type: 'big_text',
    blockType: 'text',
    label: 'Большой текст',
    canBeChild: true,
    forms: [
      {
        name: 'group_content',
        label: 'Текст',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'text',
            size: 'full',
            label: 'Содержимое блока',
          },
        ],
      },
    ],
    content: {
      group_content: [
        {
          text:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto ea repellat minima eum amet ipsa aut nesciunt vitae deserunt tempore, optio illum iste vero laborum suscipit cum saepe explicabo illo. Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
        },
      ],
    },
  },
  // диаграммы
  {
    sort: 20,
    type: 'diagrams',
    blockType: 'columns',
    label: 'Диаграммы',
    canBeChild: true,
    forms: [
      {
        name: 'group_items',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 4,
        },
        size: 'half',
        items: [
          {
            name: 'value',
            type: 'text',
            size: 'full',
            label: 'Значение, %',
          },
          {
            name: 'offset',
            type: 'text',
            size: 'full',
            label: 'Сдвиг от старта, %',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Подпись',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          value: '20',
          offset: '0',
          text:
            '<p>Планирование и анализ затрат для укрепления конкурентоспособности</p>',
        },
        {
          value: '20',
          offset: '20',
          text: '<p>Пример заполнения контента под диаграммой</p>',
        },
        {
          value: '75',
          offset: '10',
          text:
            '<p>Планирование и анализ затрат для укрепления конкурентоспособности</p>',
        },
        {
          value: '20',
          offset: '0',
          text:
            '<p>Планирование и анализ затрат для укрепления конкурентоспособности</p><p><a href="#">Загрузить документы</a></p>',
        },
      ],
    },
  },
  // CTA
  {
    sort: 90,
    type: 'cta',
    blockType: 'navigation',
    label: 'Call-to-action',
    canBeChild: true,
    forms: [
      {
        name: 'group_content',
        label: 'Настройки блока CTA',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'duration',
            type: 'text',
            size: 'half',
            label: 'Длительность',
          },
          {
            name: 'btn_text',
            type: 'text',
            size: 'half',
            label: 'Текст кнопки',
          },
          {
            name: 'reference',
            type: 'cta_reference',
            size: 'full',
            label: 'Код дисциплины из CRM',
          },
        ],
      },
    ],
    content: {
      group_content: [
        {
          duration: '5 дней, 40 академических часов, 9:30-17:45',
          btn_text: 'Расписание и цены',
          reference: [],
        },
      ],
    },
  },

  // CTA with image
  {
    sort: 90,
    type: 'ctaImage',
    blockType: 'navigation',
    label: 'Call-to-action с изображением',
    canBeChild: false,
    fullWidth: false,
    noPadding: false,
    blackBG: false,
    forms: [
      {
        name: 'group_header',
        label: 'Заголовок',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'header',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
        ],
      },
      {
        name: 'group_content',
        label: 'Настройки блока CTA',
        multiple: {
          min: 1,
          max: 2,
        },
        size: 'full',
        items: [
          {
            name: 'btn_url',
            type: 'text',
            size: 'half',
            label: 'Путь кнопки',
          },
          {
            name: 'btn_text',
            type: 'text',
            size: 'half',
            label: 'Текст кнопки',
          },
          {
            name: 'reference',
            type: 'cta_reference',
            size: 'full',
            label: 'Код дисциплины из CRM',
          },
        ],
      },
      {
        name: 'group_image',
        label: 'Изображение',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: '',
          },
        ],
      },
    ],
    content: {
      group_header: [
        {
          header: 'Заголовок',
        },
      ],
      group_content: [
        {
          btn_url: '#',
          btn_text: 'Зарегистрироваться',
          reference: [],
        },
      ],
      group_image: [
        {
          image: '/static/img/work/banner-top-img.png',
        },
      ],
    },
  },

  {
    sort: 90,
    type: 'ctaFreeEvents',
    blockType: 'navigation',
    label: 'Call-to-action бесплатных мероприятий',
    canBeChild: true,
    fullWidth: false,
    noPadding: true,
    blackBG: false,
    forms: [
      {
        name: 'group_header',
        label: 'Заголовок',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'header',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
        ],
      },
      {
        name: 'group_content',
        label: 'Настройки блока CTA',
        size: 'full',
        items: [
          {
            name: 'reference',
            type: 'cta_reference_free',
            size: 'full',
            label: 'Код бесплатных дисциплин из CRM',
          },
        ],
      },
      {
        name: 'group_image',
        label: 'Изображение',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: '',
          },
        ],
      },
    ],
    content: {
      group_header: [
        {
          header: 'Заголовок',
        },
      ],
      group_content: [
        {
          reference: [],
        },
      ],
      group_image: [
        {
          image: '/static/img/work/banner-top-img.png',
        },
      ],
    },
  },

  // Стоимость
  {
    sort: 100,
    type: 'price',
    blockType: 'advantages',
    label: 'Стоимость',
    canBeChild: true,
    forms: [
      {
        name: 'group_left',
        label: 'Блок стоимости',
        multiple: false,
        size: 'half',
        items: [
          {
            name: 'price_old',
            type: 'text',
            size: 'full',
            label: 'Предыдущая стоимость',
          },
          {
            name: 'price',
            type: 'text',
            size: 'full',
            label: 'Стоимость',
          },
          {
            name: 'price_text',
            type: 'text',
            size: 'full',
            label: 'Подпись под стоимостью',
          },
          {
            name: 'price_quote',
            type: 'text',
            size: 'full',
            label: 'Текст под звездочкой',
          },
        ],
      },
      {
        name: 'group_right',
        label: 'Описание',
        multiple: false,
        size: 'half',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Описание',
          },
        ],
      },
    ],
    content: {
      group_left: [
        {
          price_old: '960 000 ₽',
          price: '860 000 ₽',
          price_text:
            'Стоимость обучения по программе MBA PwC «Практика менеджмента» с профессиональной специализацией.',
          price_quote:
            'НДС не облагается. Физическим лицам предоставляются документы для оформления 13% налогового вычета. Возможна оплата частями. Уточните варианты оплаты у координатора программы МВА.',
        },
      ],
      group_right: [
        {
          text:
            '<h5>В стоимость входят:</h5><ul><li>Очные занятия и проектные консультации преподавателей</li><li>Полный комплект учебных материалов</li></ul><p>Вы работаете в международной компании? Или планируете получить зарубежный опыт работы? Выберите дополнительный курс «Международный менеджмент» и получите второй диплом МВА в Барселонской школе бизнеса EADA. Выездной блок школы EADA направлен на изучение специфики международного бизнеса.</p>',
        },
      ],
    },
  },
  // Спойлер
  {
    sort: 230,
    type: 'spoiler',
    blockType: 'navigation',
    label: 'Спойлер',
    forms: [
      {
        name: 'group_spoiler',
        label: '{i} блок',
        multiple: {
          min: 1,
          max: 15,
        },
        hasChildren: true,
        size: 'full',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
        ],
      },
    ],
    content: {
      group_spoiler: [
        {
          title: 'Заголовок раскрывающегося блока',
          children: [],
        },
        {
          title: 'Блок 2',
          children: [],
        },
        {
          title: 'Заголовок третьего блока',
          children: [],
        },
      ],
    },
  },
  // Табы
  {
    sort: 240,
    type: 'tabs',
    blockType: 'navigation',
    label: 'Табы',
    forms: [
      {
        name: 'group_tabs',
        label: '{i} блок',
        multiple: {
          min: 1,
          max: 10,
        },
        hasChildren: true,
        size: 'full',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
        ],
      },
    ],
    content: {
      group_tabs: [
        {
          title: 'Вкладка #1',
          children: [],
        },
        {
          title: 'Вкладка #2',
          children: [],
        },
        {
          title: 'Третья вкладка',
          children: [],
        },
      ],
    },
  },
  // Промо
  {
    sort: 150,
    type: 'promo',
    blockType: 'advantages',
    label: 'Промо',
    forms: [
      {
        name: 'promo_image',
        label: 'Изображение',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: '',
          },
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
        ],
      },
      {
        name: 'promo_desc',
        label: 'Описание',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: '',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
        ],
      },
      {
        name: 'promo_btn',
        label: 'Кнопка',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'link_url',
            type: 'text',
            size: 'half',
            label: 'Адрес кнопки',
          },
          {
            name: 'link_text',
            type: 'text',
            size: 'half',
            label: 'Текст кнопки',
          },
        ],
      },
    ],
    content: {
      promo_image: [
        {
          image: '/static/img/work/collage-img.png',
          title:
            'Программа двойного диплома МВА PwC + EADA имеет аккредитации АМВА и EQUIS',
        },
      ],
      promo_desc: [
        {
          image: '/static/img/work/collage-logo1.png',
          text:
            '<p>Вы работаете в международной компании? Или планируете получить зарубежный опыт работы?</p><p>Выберите дополнительный курс «Международный менеджмент» и получите второй диплом МВА в Барселонской школе бизнеса EADA. Выездной блок школы EADA направлен на изучение специфики международного бизнеса.</p>',
        },
      ],
      promo_btn: [
        {
          link_url: '#registration',
          link_text: 'Зарегистрироваться',
        },
      ],
    },
  },
  // диплом
  {
    sort: 110,
    type: 'diplom',
    blockType: 'advantages',
    label: 'Диплом',
    forms: [
      {
        name: 'group_desc',
        label: 'Описание',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'link_text',
            type: 'text',
            size: 'half',
            label: 'Текст ссылки',
          },
          {
            name: 'link_url',
            type: 'text',
            size: 'half',
            label: 'Ссылка',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
        ],
      },
      {
        name: 'group_images',
        label: 'Изображение',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: 'Изображение',
          },
        ],
      },
    ],
    content: {
      group_desc: [
        {
          link_text: '',
          link_url: '',
          text:
            '<p>Выпускники курса получают Диплом МВА PwC о профессиональной переподготовке.</p><p>2000+ консультационных кейсов и отраслевых исследований PwC иллюстрируют, как работают лидеры, как успешно применить бизнес-инструменты.</p>',
        },
      ],

      group_images: [
        {
          image: '/static/img/constructor/default_content/diplom.png',
        },
      ],
    },
  },
  // Кнопки
  {
    sort: 200,
    type: 'buttons',
    blockType: 'navigation',
    label: 'Кнопки',
    canBeChild: true,
    forms: [
      {
        name: 'group_buttons',
        label: 'Кнопка',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'btn_main_url',
            type: 'text',
            size: 'half',
            label: 'Путь главной кнопки',
          },
          {
            name: 'btn_main_text',
            type: 'text',
            size: 'half',
            label: 'Текст главной кнопки',
          },
          {
            name: 'btn_second_url',
            type: 'text',
            size: 'half',
            label: 'Путь второй кнопки',
          },
          {
            name: 'btn_second_text',
            type: 'text',
            size: 'half',
            label: 'Текст второй кнопки',
          },
        ],
      },
    ],
    content: {
      group_buttons: [
        {
          btn_main_url: '#',
          btn_main_text: 'Зарегистрироваться',
          btn_second_url: '#',
          btn_second_text: 'Подробнее',
        },
      ],
    },
  },
  // видео
  {
    sort: 50,
    type: 'video',
    blockType: 'gallery',
    label: 'Видео',
    canBeChild: true,
    forms: [
      {
        name: 'group_video',
        label: 'Видео',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'video',
            type: 'text',
            size: 'full',
            label: 'Ссылка на видео',
          },
          {
            name: 'video_prev',
            type: 'image',
            size: 'full',
            label: 'Превью',
          },
        ],
      },
    ],
    content: {
      group_video: [
        {
          video:
            'https://www.youtube.com/channel/UCPs4ZEVuCc_2ZYsU4D8fymQ/videos',
          video_prev: '/static/img/work/banner-top-img.png',
        },
      ],
    },
  },
  // Линейка с цифрами
  {
    sort: 20,
    type: 'line_numbers',
    blockType: 'table',
    label: 'Линейка с цифрами',
    forms: [
      {
        name: 'group_items',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 6,
        },
        size: 'half',
        items: [
          {
            name: 'number',
            type: 'text',
            size: 'full',
            label: 'Цифра',
          },
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Подпись',
          },
          colorSelect,
        ],
      },
      {
        name: 'group_subitems',
        label: '{i} пункт второй линии',
        multiple: {
          min: 1,
          max: 6,
        },
        size: 'half',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Текст',
          },
          colorSelectLine2,
        ],
      },
    ],
    content: {
      group_items: [
        {
          number: '1',
          title: 'модуль',
          color: '#5f8eff',
        },
        {
          number: '2',
          title: 'модуль',
          color: '#5f8eff',
        },
        {
          number: '3',
          title: 'модуль',
          color: '#5f8eff',
        },
      ],
      group_subitems: [
        {
          title: 'Управление изменениям',
          color: '#FFF',
        },
        {
          title: 'Презентация деловой информации',
          color: '#FFF',
        },
        {
          title: 'Бизнес-коммуникации',
          color: '#FFF',
        },
        {
          title: 'Коучинг и развитие',
          color: '#FFF',
        },
      ],
    },
  },
  // Линейка с цифрами
  {
    sort: 20,
    type: 'line_icons',
    blockType: 'table',
    label: 'Линейка с иконками',
    forms: [
      {
        name: 'group_items',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 6,
        },
        size: 'half',
        items: [
          {
            name: 'icon',
            type: 'icon',
            size: 'full',
            label: 'Иконка',
          },
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Подпись',
          },
          colorSelect,
        ],
      },
      {
        name: 'group_subitems',
        label: '{i} пункт второй линии',
        multiple: {
          min: 1,
          max: 6,
        },
        size: 'half',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Текст',
          },
          colorSelectLine2,
        ],
      },
    ],
    content: {
      group_items: [
        {
          icon: 'Alert',
          title: 'Лидерство',
          color: '#5f8eff',
        },
        {
          icon: 'Alert',
          title: 'Руководитель и организация',
          color: '#5f8eff',
        },
        {
          icon: 'Alert',
          title: 'Принятие управленческих решений',
          color: '#5f8eff',
        },
      ],
      group_subitems: [
        {
          title: 'Управление изменениям',
          color: '#FFF',
        },
        {
          title: 'Презентация деловой информации',
          color: '#FFF',
        },
        {
          title: 'Бизнес-коммуникации',
          color: '#FFF',
        },
        {
          title: 'Коучинг и развитие',
          color: '#FFF',
        },
      ],
    },
  },
  // Линейка с изображениями
  {
    sort: 20,
    type: 'line_images',
    blockType: 'table',
    label: 'Линейка с изображениями',
    forms: [
      {
        name: 'group_items',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 6,
        },
        size: 'half',
        items: [
          {
            name: 'icon',
            type: 'image',
            size: 'full',
            label: 'Изображение',
          },
          colorSelect,
        ],
      },
      {
        name: 'group_subitems',
        label: '{i} пункт второй линии',
        multiple: {
          min: 1,
          max: 6,
        },
        size: 'half',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Текст',
          },
          colorSelectLine2,
        ],
      },
    ],
    content: {
      group_items: [
        {
          icon: '/static/img/work/accord-img.png',
          color: '#5f8eff',
        },
        {
          icon: '/static/img/work/collage-logo1.png',
          color: '#5f8eff',
        },
      ],
      group_subitems: [
        {
          title: 'Управление изменениям',
          color: '#FFF',
        },
        {
          title: 'Презентация деловой информации',
          color: '#FFF',
        },
        {
          title: 'Бизнес-коммуникации',
          color: '#FFF',
        },
        {
          title: 'Коучинг и развитие',
          color: '#FFF',
        },
      ],
    },
  },
  // колонки с иконками
  {
    sort: 20,
    type: 'columns_icons',
    blockType: 'columns',
    label: 'Колонки с иконками',
    canBeChild: true,
    forms: [
      {
        name: 'group_items',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 12,
        },
        size: 'half',
        items: [
          {
            name: 'icon',
            type: 'icon',
            size: 'full',
            label: 'Иконка',
          },
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          icon: 'Vait',
          title: 'Продолжительность',
          text: '<p>2 дня, 18 академических часов</p>',
        },
        {
          icon: 'Community',
          title: 'Формат обучения',
          text:
            '<p><b>Очный.</b> Семинар может быть проведен в <a href="/event/korporativnye-programmy/">корпоративном формате</a></p>',
        },
        {
          icon: 'Profitability',
          title: 'Стоимость',
          text: '<p>39 000 руб. + НДС</p>',
        },
        {
          icon: 'Wealth',
          title: 'Скидки',
          text:
            '<p>При одновременной регистрации двух участников от одной компании – 5%, трех – 10%</p>',
        },
      ],
    },
  },
  // колонки с цифрами
  {
    sort: 20,
    type: 'columns_numbers',
    blockType: 'columns',
    label: 'Колонки с цифрами',
    canBeChild: true,
    forms: [
      {
        name: 'group_items',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 12,
        },
        size: 'half',
        items: [
          {
            name: 'number',
            type: 'text',
            size: 'full',
            label: 'Цифра',
          },
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          number: '01',
          title: 'Заголовок 1',
          text: '<p>7 ноября</p>',
        },
        {
          number: '02',
          title: 'Заголовок 2',
          text: '<p>17 ноября</p>',
        },
        {
          number: '03',
          title: 'Заголовок 1',
          text: '<p><b>7 ноября</b></p>',
        },
        {
          number: '04',
          title: 'Заголовок 2',
          text: '<p><a href="#">Подробнее</a></p>',
        },
      ],
    },
  },
  // колонки с буквами
  {
    sort: 20,
    type: 'columns_words',
    blockType: 'columns',
    label: 'Колонки с буквами',
    canBeChild: true,
    forms: [
      {
        name: 'group_items',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 12,
        },
        size: 'half',
        items: [
          {
            name: 'number',
            type: 'text',
            size: 'full',
            label: 'Буква',
          },
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          number: 'A',
          title: 'Заголовок 1',
          text: '<p>7 ноября</p>',
        },
        {
          number: 'B',
          title: 'Заголовок 2',
          text: '<p>17 ноября</p>',
        },
        {
          number: 'C',
          title: 'Заголовок 1',
          text: '<p><b>7 ноября</b></p>',
        },
        {
          number: 'D',
          title: 'Заголовок 2',
          text: '<p><a href="#">Подробнее</a></p>',
        },
      ],
    },
  },
  // колонки с произвольным текстом
  {
    sort: 20,
    type: 'columns_optional',
    blockType: 'columns',
    label: 'Колонки с произвольным текстом',
    canBeChild: true,
    forms: [
      {
        name: 'group_items',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 12,
        },
        size: 'half',
        items: [
          {
            name: 'number',
            type: 'text',
            size: 'full',
            label: 'Пункт',
          },
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          number: '7%',
          title: 'Заголовок 1',
          text: '<p>7 ноября</p>',
        },
        {
          number: '$1500',
          title: 'Заголовок 2',
          text: '<p>17 ноября</p>',
        },
        {
          number: '24/7',
          title: 'Заголовок 1',
          text: '<p><b>7 ноября</b></p>',
        },
        {
          number: '🥇',
          title: 'Заголовок 2',
          text: '<p><a href="#">Подробнее</a></p>',
        },
      ],
    },
  },
  // колонки с красной линией с иконками
  {
    sort: 20,
    type: 'columns_red_icons',
    blockType: 'columns',
    label: 'Колонки с красной полосой с иконками',
    canBeChild: true,
    forms: [
      {
        name: 'group_items',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 12,
        },
        size: 'half',
        items: [
          {
            name: 'icon',
            type: 'icon',
            size: 'full',
            label: 'Иконка',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          icon: 'Alert',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: 'Alert',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: 'Alert',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: 'Alert',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: 'Alert',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
      ],
    },
  },
  // колонки с красной линией с иконками
  {
    sort: 20,
    type: 'columns_red_words',
    blockType: 'columns',
    label: 'Колонки с красной полосой с буквами',
    canBeChild: true,
    forms: [
      {
        name: 'group_items',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 12,
        },
        size: 'half',
        items: [
          {
            name: 'icon',
            type: 'text',
            size: 'full',
            label: 'Буква',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          icon: 'А',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: 'Б',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: 'В',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: 'Г',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: 'Д',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
      ],
    },
  },
  // колонки с красной линией с цифрами
  {
    sort: 20,
    type: 'columns_red_numbers',
    blockType: 'columns',
    label: 'Колонки с красной полосой с цифрами',
    canBeChild: true,
    forms: [
      {
        name: 'group_items',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 12,
        },
        size: 'half',
        items: [
          {
            name: 'icon',
            type: 'text',
            size: 'full',
            label: 'Цифра',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          icon: '01',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: '02',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: '03',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: '04',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: '05',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
      ],
    },
  },
  // колонки с красной линией с произвольным текстом
  {
    sort: 20,
    type: 'columns_red_optional',
    blockType: 'columns',
    label: 'Колонки с красной полосой с произвольным текстом',
    canBeChild: true,
    forms: [
      {
        name: 'group_items',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 12,
        },
        size: 'half',
        items: [
          {
            name: 'icon',
            type: 'text',
            size: 'full',
            label: 'Пункт',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          icon: '🥇',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: '🥈',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: '🥉',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          icon: '⚠️',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
      ],
    },
  },
  // колонки с изображениями
  {
    sort: 90,
    type: 'columns_images',
    blockType: 'columns',
    label: 'Колонки с изображениями',
    forms: [
      {
        name: 'group_image_columns',
        label: '{i} пункт',
        multiple: {
          min: 1,
          max: 10,
        },
        size: 'half',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: 'Изображение',
          },
        ],
      },
    ],
    content: {
      group_image_columns: [
        {
          title: 'Стратегия',
          text: '<ul><li>Оплата экзамена P2 110 фунтов стерлингов</li></ul>',
          image: '/static/img/work/list-img2.png',
        },
        {
          title: 'Маркетинг',
          text:
            '<p>Вы работаете в международной компании? Или планируете получить зарубежный опыт работы? Выберите дополнительный курс «Международный менеджмент» и получите второй диплом МВА в Барселонской школе бизнеса EADA. Выездной блок школы EADA направлен на изучение специфики международного бизнеса.</p>',
          image: '/static/img/work/list-img3.png',
        },
        {
          title: 'Маркетинг',
          text:
            '<p>Вы работаете в международной компании? Или планируете получить зарубежный опыт работы?</p><p>Выберите дополнительный курс «Международный менеджмент» и получите второй диплом МВА в Барселонской школе бизнеса EADA. Выездной блок школы EADA направлен на изучение специфики международного бизнеса.</p>',
          image: '/static/img/work/list-img4.png',
        },
        {
          title: 'Маркетинг',
          text:
            '<p>Вы работаете в международной компании? Или планируете получить зарубежный опыт работы? Выберите дополнительный курс «Международный менеджмент» и получите второй диплом МВА в Барселонской школе бизнеса EADA. Выездной блок школы EADA направлен на изучение специфики международного бизнеса.</p>',
          image: '/static/img/work/list-img5.png',
        },
      ],
    },
  },
  // Шаги
  {
    sort: 260,
    type: 'steps',
    blockType: 'advantages',
    label: 'Шаги',
    forms: [
      {
        name: 'group_count',
        label: 'Настройки блока',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'count_hide',
            type: 'text',
            size: 'full',
            label: 'Скрывать после кол-ва блоков',
          },
        ],
      },
      {
        name: 'group_items',
        label: 'Блок #{i}',
        multiple: {
          min: 1,
          max: 20,
        },
        size: 'full',
        items: [
          {
            name: 'marker',
            type: 'text',
            size: 'half',
            label: 'Пункт (цифра или буква)',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст пункта',
          },
        ],
      },
    ],
    content: {
      group_count: [
        {
          count_hide: '5',
        },
      ],
      group_items: [
        {
          marker: '01',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          marker: '02',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
        {
          marker: 'A',
          text:
            '<h5>Предварительная подготовка в электронном учебном комплексе</h5><p>Чтение учебников электронной библиотеки, статей, кейсов, выполнение заданий.</p><p><a href="#">Электронный учебный комплекс</a></p>',
        },
      ],
    },
  },
  // Ключевая фраза
  {
    sort: 70,
    type: 'key_phrase',
    blockType: 'advantages',
    label: 'Ключевая фраза',
    canBeChild: true,
    forms: [
      {
        name: 'group_phrase',
        label: 'Ключевая фраза',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'text',
            size: 'full',
            label: 'Текст',
          },
        ],
      },
    ],
    content: {
      group_phrase: [
        {
          text: '90 минутный компьютерный тест, включающий 60 заданий',
        },
      ],
    },
  },
  // Цитата
  {
    sort: 75,
    type: 'quote',
    blockType: 'advantages',
    label: 'Цитата',
    canBeChild: true,
    forms: [
      {
        name: 'group_quote',
        label: 'Цитата',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'text',
            size: 'full',
            label: 'Текст',
          },
          {
            name: 'author',
            type: 'text',
            size: 'half',
            label: 'Автор',
          },
          {
            name: 'author_pos',
            type: 'text',
            size: 'half',
            label: 'Должность автора',
          },
        ],
      },
    ],
    content: {
      group_quote: [
        {
          text:
            'Я всегда говорил, что мы добьемся поставленных целей и найдем оптимальные решения задач!',
          author: 'Иванов Иван Иванович',
          author_pos: 'Заместитель заместителя',
        },
      ],
    },
  },
  // Разделитель
  {
    sort: 75,
    type: 'hr',
    blockType: 'delimeter',
    label: 'Разделитель',
    canBeChild: true,
    forms: [
      {
        name: 'group_content',
        label: 'У этого блока нет настроек',
        multiple: false,
        size: 'full',
        items: [],
      },
    ],
    content: {},
  },
  // Отступ обычный
  {
    sort: 75,
    type: 'margin',
    blockType: 'delimeter',
    label: 'Отступ',
    canBeChild: true,
    forms: [
      {
        name: 'group_content',
        label: 'У этого блока нет настроек',
        multiple: false,
        size: 'full',
        items: [],
      },
    ],
    content: {},
  },
  // Отступ большой
  {
    sort: 75,
    type: 'margin-big',
    blockType: 'delimeter',
    label: 'Отступ большой',
    canBeChild: true,
    forms: [
      {
        name: 'group_content',
        label: 'У этого блока нет настроек',
        multiple: false,
        size: 'full',
        items: [],
      },
    ],
    content: {},
  },
  // Маркированный список
  {
    sort: 30,
    type: 'html_ul',
    blockType: 'lists',
    label: 'Маркированный список',
    canBeChild: true,
    forms: [
      {
        name: 'group_html',
        label: 'Текст',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Содержимое блока',
          },
        ],
      },
    ],
    content: {
      group_html: [
        {
          text:
            '<ul><li>Nostrum porro, veniam.</li><li>Nostrum, veniam.</li><li>Nostrum porro.</li></ul>',
        },
      ],
    },
  },
  // Маркированный список
  {
    sort: 30,
    type: 'html_ol',
    blockType: 'lists',
    label: 'Нумерованный список',
    canBeChild: true,
    forms: [
      {
        name: 'group_html',
        label: 'Текст',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Содержимое блока',
          },
        ],
      },
    ],
    content: {
      group_html: [
        {
          text:
            '<ol><li>Nostrum porro, veniam.</li><li>Nostrum, veniam.</li><li>Nostrum porro.</li></ol>',
        },
      ],
    },
  },
  // Маркированный список в 2 колонки
  {
    sort: 30,
    type: 'html_ul_columns',
    blockType: 'lists',
    label: 'Маркированный список в 2 колонки',
    canBeChild: true,
    forms: [
      {
        name: 'group_html',
        label: 'Текст',
        multiple: {
          min: 2,
          max: 2,
        },
        size: 'half',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Содержимое блока',
          },
        ],
      },
    ],
    content: {
      group_html: [
        {
          text:
            '<ul><li>Nostrum porro, veniam.</li><li>Nostrum, veniam.</li><li>Nostrum porro.</li></ul>',
        },
        {
          text:
            '<ul><li>Nostrum porro, veniam.</li><li>Nostrum, veniam.</li><li>Nostrum porro.</li></ul>',
        },
      ],
    },
  },
  // Нумерованный список в 2 колонки
  {
    sort: 30,
    type: 'html_ol_columns',
    blockType: 'lists',
    label: 'Нумерованный список в 2 колонки',
    canBeChild: true,
    forms: [
      {
        name: 'group_html',
        label: 'Текст',
        multiple: {
          min: 2,
          max: 2,
        },
        size: 'half',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Содержимое блока',
          },
        ],
      },
    ],
    content: {
      group_html: [
        {
          text:
            '<ol><li>Nostrum porro, veniam.</li><li>Nostrum, veniam.</li><li>Nostrum porro.</li></ol>',
        },
        {
          text:
            '<ol><li>Nostrum porro, veniam.</li><li>Nostrum, veniam.</li><li>Nostrum porro.</li></ol>',
        },
      ],
    },
  },
  // Таблица
  {
    sort: 30,
    type: 'table-new',
    blockType: 'table',
    label: 'Таблица',
    canBeChild: true,
    forms: [
      {
        name: 'group_html',
        label: 'Текст',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'table_html',
            size: 'full',
            label: 'Содержимое блока',
          },
        ],
      },
    ],
    content: {
      group_html: [
        {
          text: [
            ['Название', 'Тип программы'],
            ['MBA', 'Интенсив'],
          ],
        },
      ],
    },
  },
  // слайдер изображения
  {
    sort: 120,
    type: 'slider_images',
    blockType: 'slider',
    label: 'Слайдер фото (обрезка по размеру слайдера)',
    forms: [
      {
        name: 'group_items',
        label: '{i} слайд',
        multiple: {
          min: 1,
          max: 10,
        },
        size: 'full',
        items: [
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: 'Изображение',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          image: '/static/img/work/video.jpg',
        },
        {
          image: '/static/img/work/collage-img.png',
        },
      ],
    },
  },
  // слайдер изображения
  {
    sort: 120,
    type: 'slider_images_vertical',
    blockType: 'slider',
    label: 'Слайдер фото (без обрезки фото)',
    forms: [
      {
        name: 'group_items',
        label: '{i} слайд',
        multiple: {
          min: 1,
          max: 10,
        },
        size: 'full',
        items: [
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: 'Изображение',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          image: '/static/img/work/video.jpg',
        },
        {
          image: '/static/img/work/collage-img.png',
        },
      ],
    },
  },

  // slider с контентом
  {
    sort: 60,
    type: 'slider_content',
    blockType: 'slider',
    label: 'Слайдер с контентом',
    forms: [
      {
        name: 'slide_content',
        label: '{i} Слайд',
        multiple: {
          min: 1,
          max: 10,
        },
        size: 'half',
        items: [
          {
            name: 'icon',
            type: 'icon',
            size: 'full',
            label: 'Иконка',
          },
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
          {
            name: 'link_text',
            type: 'text',
            size: 'half',
            label: 'Текст ссылки',
          },
          {
            name: 'link_url',
            type: 'text',
            size: 'half',
            label: 'Ссылка',
          },
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: 'Изображение',
          },
        ],
      },
    ],
    content: {
      slide_content: [
        {
          icon: 'Alert',
          title: 'Кейсы реальных компаний',
          text:
            '<p><ul><li>Возможный пункт первого списка</li><li>Второй пункт</li></ul>2000+ консультационных кейсов и отраслевых исследований PwC иллюстрируют, как работают лидеры, как успешно применить бизнес-инструменты.</p>',
          link_text: 'Подробнее',
          link_url:
            'https://www.pwc.com/gx/en/industries/financial-services.html',
          image: '/static/img/work/split-slider-img.png',
        },
        {
          icon: 'Alert',
          title: 'Кейсы реальных компаний',
          text:
            '<p>2000+ консультационных кейсов и отраслевых исследований PwC иллюстрируют, как работают лидеры, как успешно применить бизнес-инструменты.</p>',
          link_text: 'Подробнее',
          link_url:
            'https://www.pwc.com/gx/en/industries/financial-services.html',
          image: '/static/img/work/split-slider-img.png',
        },
      ],
    },
  },
  // Текст с картинкой
  {
    sort: 270,
    type: 'text_image',
    blockType: 'image',
    label: 'Текст с картинкой',
    forms: [
      {
        name: 'group_content',
        label: 'Блок на сером фоне',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'icon',
            type: 'icon',
            size: 'full',
            label: 'Иконка',
          },
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: 'Изображение',
          },
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Текст',
          },
        ],
      },
    ],
    content: {
      group_content: [
        {
          icon: 'Avatar',
          image: '/static/img/constructor/default_content/peoples.jpg',
          title: 'Целевая аудитория',
          text:
            '<p>Руководители среднего звена, менеджеры проектов, владельцы бизнеса, а также профессионалы, желающие повысить свои коммуникативные навыки.</p>',
        },
      ],
    },
  },
  // Ключевые эксперты
  {
    sort: 250,
    type: 'slider_expert',
    blockType: 'gallery',
    label: 'Эксперты',
    forms: [
      {
        name: 'slide_content',
        label: 'Эксперт #{i}',
        multiple: {
          min: 1,
          max: 20,
        },
        size: 'half',
        items: [
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: 'Изображение',
          },
          {
            name: 'expert_name',
            type: 'text',
            size: 'full',
            label: 'Имя',
          },
          {
            name: 'expert_post',
            type: 'text',
            size: 'full',
            label: 'Должность',
          },
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Содержимое блока',
          },
        ],
      },
    ],
    content: {
      slide_content: [
        {
          image: '/static/img/constructor/exp-face.png',
          expert_name: 'Григорий Борисенкo',
          expert_post: 'Директор, Отдел анализа и контроля рисков',
          text: 'Региональный менеджер ОАО “ОАО”',
        },
        {
          image: '/static/img/constructor/exp-face.png',
          expert_name: 'Юрий Борисенкo',
          expert_post: 'Заместитель, Отдел анализа и контроля рисков',
          text: 'Региональный менеджер ОАО ООО',
        },
      ],
    },
  },
  {
    sort: 260,
    type: 'reviews',
    blockType: 'reviews',
    label: 'Отзывы',
    fullWidth: true,
    forms: [
      {
        name: 'group_reviews',
        label: '{i} отзыв',
        multiple: {
          min: 1,
          max: 40,
        },
        size: 'full',
        items: [
          {
            name: 'key_phrase',
            type: 'text',
            size: 'full',
            label: 'Ключевая фраза',
          },
          {
            name: 'text',
            type: 'text',
            size: 'full',
            label: 'Текст',
          },
          {
            name: 'author',
            type: 'text',
            size: 'half',
            label: 'Автор',
          },
          {
            name: 'sign',
            type: 'text',
            size: 'half',
            label: 'Подпись',
          },
        ],
      },
    ],
    content: {
      group_reviews: [
        {
          key_phrase: 'Я продвинулся по карьерной лестнице',
          text:
            'Вы работаете в международной компании? Или планируете получить зарубежный опыт работы? Выберите дополнительный курс «Международный менеджмент» и получите второй диплом МВА в Барселонской школе бизнеса EADA. Выездной блок школы EADA направлен на изучение специфики         международного бизнеса.',
          author: 'Юрий Александров',
          sign: 'Региональный менеджер ОАО “ОАО”',
        },
        {
          key_phrase: 'Мне стало легче принимать решения',
          text:
            'Вы работаете в международной компании? Или планируете получить зарубежный опыт работы? Выберите дополнительный курс «Международный менеджмент» и получите второй диплом МВА в Барселонской школе бизнеса EADA. Выездной блок школы EADA направлен на изучение специфики         международного бизнеса.',
          author: 'Юрий Александров',
          sign: 'Региональный менеджер ОАО “ОАО”',
        },
      ],
    },
  },
  // Поп-ап
  {
    sort: 270,
    type: 'popup',
    blockType: 'navigation',
    label: 'Поп-ап',
    forms: [
      {
        name: 'group_popup',
        label: 'Поп-ап',
        multiple: false,
        hasChildren: true,
        size: 'full',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'half',
            label: 'Заголовок',
          },
          {
            name: 'idkey',
            type: 'text',
            size: 'half',
            label: 'Ключ поп-апа (#popup-...)',
          },
        ],
      },
    ],
    content: {
      group_popup: [
        {
          title: 'Заголовок поп-апа',
          idkey: 'about-program',
          children: [],
        },
      ],
    },
  },
  // Файлы
  {
    sort: 280,
    type: 'files',
    blockType: 'columns',
    label: 'Файлы',
    canBeChild: true,
    forms: [
      {
        name: 'group_files',
        label: 'Файл',
        multiple: {
          min: 1,
          max: 4,
        },
        size: 'half',
        items: [
          {
            name: 'file',
            type: 'file',
            size: 'full',
            label: 'Файл',
          },
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Название файла',
          },
          {
            name: 'desc',
            type: 'html',
            size: 'full',
            label: 'Подпись',
          },
        ],
      },
    ],
    content: {
      group_files: [
        {
          file: '/upload/1.pdf',
          title: 'Сертификат',
          desc: '<p>Версия от 15.02</p>',
        },
        {
          file: '/upload/1.pdf',
          title: 'Требования к поступающим',
          desc: '<p>pdf, 1.7 mb</p>',
        },
      ],
    },
  },

  /*

  // Отзывы

  // Табы
  {
    sort: 240,
    type: 'tabs',
    blockType: 'tabs',
    label: 'Табы',
    forms: [
      {
        name: 'group_tabs',
        label: '{i} вкладка',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
          {
            name: 'add_button',
            type: 'button',
            size: 'full',
            label: '',
          },
        ],
      },
    ],
    content: {
      group_tabs: [
        {
          title: 'F - базовый уровень',
          add_button: 'Добавить вкладку',
        },
      ],
    },
  },

*/
  //   __   ____  __  ____  ____    ____  __     __    ___  __ _  ____
  //  / _\ / ___)(  )(    \(  __)  (  _ \(  )   /  \  / __)(  / )/ ___)
  // /    \\___ \ )(  ) D ( ) _)    ) _ (/ (_/\(  O )( (__  )  ( \___ \
  // \_/\_/(____/(__)(____/(____)  (____/\____/ \__/  \___)(__\_)(____/
  //

  // Заголовок уровень 1
  {
    sort: 510,
    type: 'heading_level_1_aside',
    blockType: 'heading',
    label: 'Заголовок H1',
    onlyAside: true,
    forms: [
      {
        name: 'group_heading',
        label: 'Заголовок H1',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
        ],
      },
    ],
    content: {
      group_heading: [
        {
          title: 'Заголовок первого уровня',
        },
      ],
    },
  },
  // Заголовок уровень 2
  {
    sort: 520,
    type: 'heading_level_2_aside',
    blockType: 'heading',
    label: 'Заголовок H2',
    onlyAside: true,
    forms: [
      {
        name: 'group_heading',
        label: 'Заголовок H2',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
        ],
      },
    ],
    content: {
      group_heading: [
        {
          title: 'Заголовок второго уровня',
        },
      ],
    },
  },
  // Заголовок уровень 2
  {
    sort: 530,
    type: 'heading_level_3_aside',
    blockType: 'heading',
    label: 'Заголовок H3',
    onlyAside: true,
    forms: [
      {
        name: 'group_heading',
        label: 'Заголовок H3',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Заголовок',
          },
        ],
      },
    ],
    content: {
      group_heading: [
        {
          title: 'Заголовок третьего уровня',
        },
      ],
    },
  },
  // изображение
  {
    sort: 540,
    type: 'image-aside',
    blockType: 'gallery',
    label: 'Изображение',
    onlyAside: true,
    forms: [
      {
        name: 'group_image',
        label: 'Изображение',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: 'Изображение',
          },
        ],
      },
    ],
    content: {
      group_image: [
        {
          image: '/static/img/work/collage-img.png',
        },
      ],
    },
  },
  // изображение ссылка
  {
    sort: 540,
    type: 'image-link-aside',
    blockType: 'gallery',
    label: 'Изображение-ссылка',
    onlyAside: true,
    forms: [
      {
        name: 'group_image',
        label: 'Изображение',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'image',
            type: 'image',
            size: 'full',
            label: 'Изображение',
          },
          {
            name: 'link_url',
            type: 'text',
            size: 'full',
            label: 'Адрес ссылки',
          },
        ],
      },
    ],
    content: {
      group_image: [
        {
          image: '/static/img/work/collage-img.png',
          link_url: '/',
        },
      ],
    },
  },
  // html text
  {
    sort: 500,
    type: 'html_editor_aside',
    blockType: 'html',
    label: 'Tекст',
    onlyAside: true,
    forms: [
      {
        name: 'group_html',
        label: 'Текст',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Содержимое блока',
          },
        ],
      },
    ],
    content: {
      group_html: [
        {
          text:
            '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores ea, itaque fugit distinctio labore quibusdam, consequuntur corporis, cum excepturi error quos. Obcaecati deleniti, autem tempore dolorem fuga rem aliquam ipsum.</p>',
        },
      ],
    },
  },
  // Кнопки
  {
    sort: 200,
    type: 'buttons_aside',
    blockType: 'buttons',
    label: 'Кнопки',
    onlyAside: true,
    forms: [
      {
        name: 'group_buttons',
        label: 'Кнопка',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'btn_main_url',
            type: 'text',
            size: 'half',
            label: 'Путь главной кнопки',
          },
          {
            name: 'btn_main_text',
            type: 'text',
            size: 'half',
            label: 'Текст главной кнопки',
          },
          {
            name: 'btn_second_url',
            type: 'text',
            size: 'half',
            label: 'Путь второй кнопки',
          },
          {
            name: 'btn_second_text',
            type: 'text',
            size: 'half',
            label: 'Текст второй кнопки',
          },
        ],
      },
    ],
    content: {
      group_buttons: [
        {
          btn_main_url: '#',
          btn_main_text: 'Зарегистрироваться',
          btn_second_url: '#',
          btn_second_text: 'Подробнее',
        },
      ],
    },
  },
  // видео
  {
    sort: 560,
    type: 'video_aside',
    blockType: 'gallery',
    label: 'Видео',
    onlyAside: true,
    forms: [
      {
        name: 'group_video',
        label: 'Видео',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'video',
            type: 'text',
            size: 'full',
            label: 'Ссылка на видео',
          },
          {
            name: 'video_prev',
            type: 'image',
            size: 'full',
            label: 'Превью',
          },
          {
            name: 'text',
            type: 'text',
            size: 'full',
            label: 'Подпись под видео',
          },
        ],
      },
    ],
    content: {
      group_video: [
        {
          video:
            'https://www.youtube.com/channel/UCPs4ZEVuCc_2ZYsU4D8fymQ/videos',
          video_prev: '/static/img/work/banner-top-img.png',
          text: 'Видео с церемонии награждения',
        },
      ],
    },
  },
  // Разделитель
  {
    sort: 75,
    type: 'hr_aside',
    blockType: 'delimeter',
    label: 'Разделитель',
    onlyAside: true,
    forms: [
      {
        name: 'group_content',
        label: 'У этого блока нет настроек',
        multiple: false,
        size: 'full',
        items: [],
      },
    ],
    content: {},
  },
  // Отступ обычный
  {
    sort: 75,
    type: 'margin_aside',
    blockType: 'delimeter',
    label: 'Отступ',
    onlyAside: true,
    forms: [
      {
        name: 'group_content',
        label: 'У этого блока нет настроек',
        multiple: false,
        size: 'full',
        items: [],
      },
    ],
    content: {},
  },
  // Отступ большой
  {
    sort: 75,
    type: 'margin-big_aside',
    blockType: 'delimeter',
    label: 'Отступ большой',
    onlyAside: true,
    forms: [
      {
        name: 'group_content',
        label: 'У этого блока нет настроек',
        multiple: false,
        size: 'full',
        items: [],
      },
    ],
    content: {},
  },
  // Маркированный список на сером фоне
  {
    sort: 500,
    type: 'ul_grey_aside',
    blockType: 'html',
    label: 'Маркированный список на сером фоне',
    onlyAside: true,
    forms: [
      {
        name: 'group_html',
        label: 'Текст',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Список',
          },
        ],
      },
    ],
    content: {
      group_html: [
        {
          text:
            '<ul><li>Nostrum porro, veniam.</li><li>Nostrum, veniam.</li><li>Nostrum porro.</li></ul>',
        },
      ],
    },
  },
  // Нумерованный список на сером фоне
  {
    sort: 500,
    type: 'ol_grey_aside',
    blockType: 'html',
    label: 'Нумерованный список на сером фоне',
    onlyAside: true,
    forms: [
      {
        name: 'group_html',
        label: 'Текст',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Список',
          },
        ],
      },
    ],
    content: {
      group_html: [
        {
          text:
            '<h3>Почему академия PwC?</h3><ol><li>Уникальные материалы, разработанные экспертами PwC</li><li>Четкая структура и доступная увлекательная форма изложения материала</li><li>Закрепление полученных знаний с помощью практических заданий, игр, бизнес-кейсов, видео</li><li>Создание атмосферы заинтересованности на занятиях, вовлечение участников в дискуссии</li></ol>',
        },
      ],
    },
  },
  // Нумерованный список на сером фоне
  {
    sort: 500,
    type: 'ol_aside',
    blockType: 'html',
    label: 'Нумерованный список',
    onlyAside: true,
    forms: [
      {
        name: 'group_html',
        label: 'Текст',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Список',
          },
        ],
      },
    ],
    content: {
      group_html: [
        {
          text:
            '<ol><li>Nostrum porro, veniam.</li><li>Nostrum, veniam.</li><li>Nostrum porro.</li></ol>',
        },
      ],
    },
  },
  // Нумерованный список на сером фоне
  {
    sort: 500,
    type: 'ul_aside',
    blockType: 'lists',
    label: 'Маркированный список',
    onlyAside: true,
    forms: [
      {
        name: 'group_html',
        label: 'Текст',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Список',
          },
        ],
      },
    ],
    content: {
      group_html: [
        {
          text:
            '<ul><li>Nostrum porro, veniam.</li><li>Nostrum, veniam.</li><li>Nostrum porro.</li></ul>',
        },
      ],
    },
  },
  // Ссылки
  {
    sort: 550,
    type: 'list_links_aside',
    blockType: 'lists',
    label: 'Ссылки',
    onlyAside: true,
    forms: [
      {
        name: 'group_items',
        label: 'Ссылки',
        multiple: false,
        size: 'full',
        items: [
          {
            name: 'text',
            type: 'html',
            size: 'full',
            label: 'Ссылки',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          text:
            '<p><a>Nostrum porro, veniam.</a></p><p><a>Lorem ipsum dolor sit amet</a></p><p><a>Earum animi, et amet illum quae veniam</a></p>',
        },
      ],
    },
  },

  /*
  // Список
  {
    sort: 540,
    type: 'list_aside',
    blockType: 'lists',
    label: 'Нумерованный список',
    onlyAside: true,
    forms: [
      {
        name: 'group_items',
        label: 'Пункт #{i}',
        multiple: {
          min: 1,
          max: 20,
        },
        size: 'full',
        items: [
          {
            name: 'title',
            type: 'text',
            size: 'full',
            label: 'Текст пункта',
          },
        ],
      },
    ],
    content: {
      group_items: [
        {
          title: 'Бюджет компании',
        },
        {
          title: 'Управленческий учет',
        },
      ],
    },
  },


*/
];
